import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, isRef as _isRef } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("确认");

import { ref, computed, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { getSalesmanRoleTypeList, getSalesmanTypeList } from '@/request';
import { useStore } from 'vuex';
export default {
  name: 'SetRoleModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const salesmanTypeList = ref([]);
    const salesmanRoleTypeList = ref([]);
    const store = useStore();
    const roleType = store.state.user.userType === 1 ? 2 : 1;
    let salesmanTypeAllList = [];
    getSalesmanRoleTypeList({}, {
      params: {
        roleType
      }
    }).then(data => {
      salesmanRoleTypeList.value = data;
    });
    const employeeRoleTypeList = ref([{
      id: 1,
      text: '企业负责人'
    }, {
      id: 2,
      text: '部门负责人'
    }, {
      id: 3,
      text: '业务员'
    }]);
    getSalesmanTypeList().then(data => {
      salesmanTypeAllList = data;
    });
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const defaultForm = {
      salesmanNote: '',
      businessCategory: '1',
      // salesmanRoleId: '',
      position: '',
      email: '',
      employeeCode: '',
      isLoginWeb: '0',
      employeeType: 3
    };
    const form = ref(_objectSpread({}, defaultForm));
    const formRef = ref(null);
    watch(() => props.modelValue, newVal => {
      if (newVal && Object.keys(props.editData || {}).length === 0) {
        var _formRef$value;

        (_formRef$value = formRef.value) === null || _formRef$value === void 0 ? void 0 : _formRef$value.resetFields();
        form.value = _objectSpread({}, defaultForm);
      } else if (newVal) {
        form.value = _objectSpread({}, props.editData);

        if (!form.value.employeeType) {
          form.value.employeeType = 3;
        }

        if (!form.value.isLoginWeb) {
          form.value.isLoginWeb = '0';
        }

        form.value.businessCategory;
        salesmanTypeList.value = salesmanTypeAllList.filter(item => {
          if (form.value.supplier_category === 1) {
            return item.id === '3';
          }

          return item.id !== '3';
        });
      }
    }, {
      flush: 'post'
    });

    function confirm() {
      formRef.value.validate(e => {
        if (e) {
          emit('success', form.value);
        }
      });
    }

    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        title: "设置角色",
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _isRef(visible) ? visible.value = $event : null),
        "destroy-on-close": "",
        "append-to-body": "",
        width: "1000px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[6] || (_cache[6] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirm
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: form.value,
          "label-width": "100px",
          ref_key: "formRef",
          ref: formRef
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "业务员类型",
                prop: "businessCategory"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: form.value.businessCategory,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.businessCategory = $event)
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(salesmanTypeList.value, item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      label: item.text,
                      value: item.id,
                      key: item.id
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "团队角色",
                prop: "employeeType"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: form.value.employeeType,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.employeeType = $event)
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(employeeRoleTypeList.value, item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      label: item.text,
                      value: item.id,
                      key: item.id
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "职位",
                prop: "position"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.position,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.position = $event)
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "邮箱",
                prop: "email"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.email,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.email = $event)
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "工号",
                prop: "employeeCode"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.employeeCode,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.value.employeeCode = $event)
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "后台权限",
                prop: "isLoginWeb"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: form.value.isLoginWeb,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.value.isLoginWeb = $event)
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_option, {
                    label: "是",
                    value: "1"
                  }), _createVNode(_component_el_option, {
                    label: "否",
                    value: "0"
                  })]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};